export default __webpack_public_path__ + "static/montaigne-da8c2b277f001cf149169b0b78e1930c.svg";